import { TagManager } from '@navent-jobs/config'
import { removeAccents } from '../../constants/remove-accents'

const productoLabelConverter = (label) => {
  if (label == 'Gratis') return 'Clasic'
  if (label == 'B | Hunter') return 'Hunter'
  return removeAccents(label)
}

const accionConverter = (accion) => {
  if (accion == 'Publicar ahora') return 'Publicar'
  if (accion == 'Comprar ahora') return 'Comprar'
  return removeAccents(accion)
}

export const AvisosListadoDataLayers = {
  contentGroup: ({ stockTotal }) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackContentGroup',
        content_group: 'Empresas - Listado de Avisos',
        stock: stockTotal,
        eventCallback,
      })
    }),

  productosChangePais: (countryName) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Filtro productos - pais',
        eventLabel: `${removeAccents(countryName)}`,
        eventCallback,
      })
    }),
  productosClick: (label, accion) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Click a productos',
        eventLabel: `${productoLabelConverter(label)}-${accionConverter(accion)}`,
        eventCallback,
      })
    }),
  productosComprarMasClick: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Productos - Comprar mas productos',
        eventLabel: 'CTA - Comprar mas productos',
        eventCallback,
      })
    }),
  modalDeleteDesplegar: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Estas seguro que queres eliminar el aviso',
        eventLabel: 'Impresion modal',
        eventCallback,
      })
    }),
  modalDeleteClick: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Estas seguro que queres eliminar el aviso',
        eventLabel: `Click modal - ${eventLabel}`,
        eventCallback,
      })
    }),
  modalFinalizarDesplegar: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Estas seguro que queres finalizar el aviso',
        eventLabel: 'Impresion modal',
        eventCallback,
      })
    }),
  modalFinalizarClick: (eventLabel, eventValue = 'NA') =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Por que queres finalizar el aviso',
        eventLabel: `Click modal - ${eventLabel}`,
        eventValue: eventValue,
        eventCallback,
      })
    }),
  modalDesktopDesplegar: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Accede desde tu computadora',
        eventLabel: 'Impresion modal',
        eventCallback,
      })
    }),
  modalDesktopClick: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Accede desde tu computadora',
        eventLabel: `Click modal - ${eventLabel}`,
        eventCallback,
      })
    }),
  modalPermisosDesplegar: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Permisos de acceso',
        eventLabel: 'Impresion modal',
        eventCallback,
      })
    }),
  modalPermisosClick: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - Permisos de accesos',
        eventLabel: `Click modal - ${eventLabel}`,
        eventCallback,
      })
    }),
  modalSinUsuariosDesplegar: () =>
  new Promise((eventCallback) => {
    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Empresas - Listado de Avisos',
      eventAction: 'Modal - No tenes usuarios en tu cuenta',
      eventLabel: 'Impresion modal',
      eventCallback,
    })
  }),
  modalSinUsuariosClick: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Modal - No tenes usuarios en tu cuenta',
        eventLabel: `Click modal - ${eventLabel}`,
        eventCallback,
      })
    }),
  filtrosClickTitulo: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Buscar - Campo titulo del aviso',
        eventLabel: 'Click - Busqueda titulo del aviso',
        eventCallback,
      })
    }),
  filtrosSeleccionarOpcion: (filtro: 'Usuario' | 'Aviso', opcion) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: `Filtro avisos - ${filtro}`,
        eventLabel: opcion,
        eventCallback,
      })
    }),
  tablaClickOpcionesMenu: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Opciones de avisos',
        eventLabel,
        eventCallback,
      })
    }),
  tablaDesplegarMenuMobile: () =>
    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Empresas - Listado de Avisos',
      eventAction: 'Desplegar informacion del aviso (mobile)',
    }),
  tablaClickTitle: (eventLabel, tipoAnuncio) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Click al aviso',
        tipoAnuncio,
        eventLabel,
        eventCallback,
      })
    }),
  tablaClickPaginado: (eventLabel) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Empresas - Listado de Avisos',
        eventAction: 'Paginado',
        eventLabel,
        eventCallback,
      })
    }),
  atrasClick: () =>
  new Promise((eventCallback) => {
    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Empresas - Listado de Avisos',
      eventAction: 'Volver atras',
      eventLabel: 'Click - Volver atras',
      eventCallback,
    })
  }),
  modalNecesitasCreditosDesplegar: () =>
  new Promise((eventCallback) => {
    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Empresas - Listado de Avisos',
      eventAction: 'Modal - Necesitas creditos para publicar',
      eventLabel: 'Impresion modal',
      eventCallback,
    })
  }),
  modalNecesitasCreditosClick: (eventLabel) =>
  new Promise((eventCallback) => {
    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Empresas - Listado de Avisos',
      eventAction: 'Modal - Necesitas creditos para publicar',
      eventLabel: `Click modal - ${eventLabel}`,
      eventCallback,
    })
  }),
}
